import * as React from "react";
import {
    Button,
    FormGroup,
    Label,
    Input,
    CustomInput,
    Row,
    Col
} from "reactstrap";
import { connect } from "react-redux";
import Header from "./Header";
import { RootState } from "../../store";
import {
    ApplicationAction,
    setContactInformation,
    gotoStep,

    setApplicationId
} from "../../store/application/applicationActions";
import { FormStep, Step } from "../../store/application/applicationState";
import { EmailAttribute } from "../../models/emailattribute";
import { MobileAttribute } from "../../models/mobileattribute";
import { FullNameAttribute } from "../../models/fullnameattribute";
import ApplicationContent from "../applicationContent";
import ApplicationFooter from "../applicationFooter";
import { trackEvent } from "../../util/gtm";
import { ApplicationApi, AseApi, } from "../../lib-api";
import { apiConfiguration } from "../../api-configuration";
import { AddressAttribute } from "../../models/Addressattribute";
import { PostalCodeAttribute } from "../../models/Postalcodeattribute";
import { CityNameAttribute } from "../../models/Citynameattribute";

interface StepThreeState {
    dirty: boolean;
    name?: string;
    mobile?: string;
    email?: string;
    address?: string;
    postalcode?: string;
    city?: string;
    loanAmount?: number;
    repaymentPeriod?: number;
    accepted: boolean;
    startAmount?: number;
    marketingConsent: boolean;
    id: string;
}

type Props = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

class StepThree extends React.Component<Props, StepThreeState> {
    constructor(props: Props) {
        super(props);

        this.state = {
            dirty: false,
            name: props.application.data.name,
            mobile: props.application.data.mobile,
            email: props.application.data.email,
            //address: props.application.data.address,
            //postalcode: props.application.data.postalcode,
            //city: props.application.data.city,
            loanAmount: props.application.data.loanAmount,
            repaymentPeriod: props.application.data.repaymentPeriod,
            accepted: false,
            startAmount: props.application.data.startAmount,
            id: props.application.application.id,
            marketingConsent: false

        };

        this.submit = this.submit.bind(this);
    }
    acceptedChange = e => {
        const { accepted } = e.target;
        this.setState({
            accepted: !this.state.accepted
        });
    };

    async submit() {
        this.setState({ dirty: true });
        const nameValid = !FullNameAttribute.hasError(this.state.name);
        const mobileValid = !MobileAttribute.hasError(this.state.mobile);
        const emailValid = !EmailAttribute.hasError(this.state.email);
        const acceptedValid = this.state.accepted;
        if (nameValid && mobileValid && emailValid && acceptedValid == true) {
            var applicationApi = new ApplicationApi(apiConfiguration);
            try {

                const id = await applicationApi.apiApplicationsCreateApplicationPut({
                    email: this.state.email,
                    name: this.state.name,
                    phone: this.state.mobile,
                    loanAmount: this.state.loanAmount,
                    repaymentPeriod: this.state.repaymentPeriod,
                    startAmount: this.state.startAmount,
                    marketingConsent: this.state.marketingConsent


                });
                this.props.setApplicationId(id);
                console.log(id);
                var newid = id.replace('"', '');
                newid = newid.replace('"', '');
                window.location.href = "/w-" + newid;
            }
            catch (e) {

            }
            trackEvent("Ansøg", "", "")
        }

    }

    stepBack = step => {
        {

            if (step == "2" || step == "3") {
                return <Button className="back" onClick={() => this.props.previous(Step.Amount)}>
                           <img src="../images/arrow-left-short.svg"/> Tilbage
                                </Button>
            }
            else {
                return <Button className="back" onClick={() => this.props.previous(Step.AmountAlt)}>
                    <img src="../images/arrow-left-short.svg" />Tilbage
                               </Button>
            }
        }
    }

    marketingChange = e => {
        const { accepted } = e.target;
        this.setState({
            marketingConsent: !this.state.marketingConsent
        });
    };

    render() {
        var params = window.location.search.toString();
        var regex = /((&|\?)step=)[0-9]{1,2}/gi;
        if (params != "") {
            params = params.replace(regex, "$1" + "3");
        }
        var stepQuery = window.location.protocol + "//" + window.location.host + window.location.pathname + params;
        window.history.pushState({ path: stepQuery }, '', stepQuery)
        return (
            <div>
                <Header formStep={FormStep.Contact} step={Step.Contact} />
                <ApplicationContent>
                    <FormGroup>
                        <Label for="name" className="text-uppercase font-weight-bold">
                            Dit Navn
                        </Label>
                        <Input
                            className={
                                this.state.dirty && FullNameAttribute.hasError(this.state.name)
                                    ? "is-invalid"
                                    : ""
                            }
                            type="text"
                            id="name"
                            name="name"
                            placeholder="Anders Andersen"
                            value={this.state.name}
                            onChange={event => this.setState({ name: event.target.value })}
                        />
                        {this.state.dirty &&
                            FullNameAttribute.hasError(this.state.name) && (
                                <div className="invalid-feedback">
                                    {FullNameAttribute.getErrorMessage()}
                                </div>
                            )}
                    </FormGroup>

                    <FormGroup>
                        <Label for="mobile" className="text-uppercase font-weight-bold">
                            Dit Mobilnummer
            </Label>
                        <Input
                            className={
                                this.state.dirty && MobileAttribute.hasError(this.state.mobile)
                                    ? "is-invalid"
                                    : ""
                            }
                            type="text"
                            id="mobile"
                            name="mobile"
                            inputMode="numeric"
                            placeholder="12345678"
                            value={this.state.mobile}
                            onChange={event => this.setState({ mobile: event.target.value })}
                        />
                        {this.state.dirty &&
                            MobileAttribute.hasError(this.state.mobile) && (
                                <div className="invalid-feedback">
                                    {MobileAttribute.getErrorMessage()}
                                </div>
                            )}
                    </FormGroup>

                    <FormGroup>
                        <Label for="email" className="text-uppercase font-weight-bold">
                            Din Email
            </Label>
                        <Input
                            className={
                                this.state.dirty && EmailAttribute.hasError(this.state.email)
                                    ? "is-invalid"
                                    : ""
                            }
                            type="email"
                            id="email"
                            name="email"
                            placeholder="eksempel@mail.dk"
                            value={this.state.email}
                            onChange={event => this.setState({ email: event.target.value })}
                        />
                        {this.state.dirty && EmailAttribute.hasError(this.state.email) && (
                            <div className="invalid-feedback">
                                {EmailAttribute.getErrorMessage()}
                            </div>
                        )}
                    </FormGroup>

                    <FormGroup className="NoMargin">

                        <CustomInput
                            invalid={this.state.dirty && !this.state.accepted}
                            type="checkbox"
                            name="accepted"
                            id="accepted"
                            onChange={this.acceptedChange}
                            label={

                                <span>
                                    Jeg accepterer privatlivspolitik <a target="_blank" href="https://lendmore.dk/privatlivspolitik">Læs mere her</a>
                                </span>

                            }
                        />

                        <Label for="accepted" className="">

                        </Label>
                    </FormGroup>

                    <FormGroup className="NoMargin">

                        <CustomInput
                            type="checkbox"
                            name="marketingConsent"
                            id="marketingConsent" 
                            onChange={this.marketingChange}
                            label={

                                <span>
                                    Ja tak, Lendmore som er ejet af Admill ApS, må behandle mine oplysninger og sende mig markedsføringsmateriale om lånetilbud og relaterede produkter fra vores <a target="_blank" href="/samarbejdspartnere">samarbejdspartnere</a> via e-mail og SMS. Du kan til enhver tid tilbagekalde dit samtykke. <a target="_blank" href="https://lendmore.dk/privatlivspolitik">Læs vores privatlivspolitik</a>
                                </span>

                            }
                        />

                        <Label for="marketingConsent" className="">

                        </Label>
                    </FormGroup>

                </ApplicationContent>
                <ApplicationFooter>
                    <Row>
                        <Col className="col-12 d-flex">
                            {this.stepBack(this.props.application.application.lastStep.toString())}
                            <Button className="ansoeg" onClick={() => {
                                this.submit();
                            }}>
                                Ansøg
                        </Button>
                        </Col>
                    </Row>
                </ApplicationFooter>
            </div>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    application: state.applicationState
});

const mapDispatchToProps = (dispatch: (action: ApplicationAction) => void) => ({
    next: () => dispatch(gotoStep(Step.Marital)),
    previous: (step: Step) => dispatch(gotoStep(step)),
    setContactInformation: (name: string, mobile: string, email: string) =>
        dispatch(setContactInformation(name, mobile, email)),
    setApplicationId: (id: string) =>
        dispatch(setApplicationId(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(StepThree);
